import { render, staticRenderFns } from "./merchantFeedback.vue?vue&type=template&id=43417108&"
import script from "./merchantFeedback.vue?vue&type=script&lang=js&"
export * from "./merchantFeedback.vue?vue&type=script&lang=js&"
import style0 from "./merchantFeedback.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports